var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCursorCrosshair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_26_46405)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 1.5C12.7574 1.5 11.75 2.50736 11.75 3.75V9.75H5.75C4.50736 9.75 3.5 10.7574 3.5 12C3.5 13.2426 4.50736 14.25 5.75 14.25H11.75V20.25C11.75 21.4926 12.7574 22.5 14 22.5C15.2426 22.5 16.25 21.4926 16.25 20.25V14.25H22.25C23.4926 14.25 24.5 13.2426 24.5 12C24.5 10.7574 23.4926 9.75 22.25 9.75H16.25V3.75C16.25 2.50736 15.2426 1.5 14 1.5Z",
    fill: "#0A0C17"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.25 11.25H5.75C5.33579 11.25 5 11.5858 5 12C5 12.4142 5.33579 12.75 5.75 12.75H13.25V20.25C13.25 20.6642 13.5858 21 14 21C14.4142 21 14.75 20.6642 14.75 20.25V12.75H22.25C22.6642 12.75 23 12.4142 23 12C23 11.5858 22.6642 11.25 22.25 11.25H14.75V3.75C14.75 3.33579 14.4142 3 14 3C13.5858 3 13.25 3.33579 13.25 3.75V11.25ZM11.75 3.75C11.75 2.50736 12.7574 1.5 14 1.5C15.2426 1.5 16.25 2.50736 16.25 3.75V9.75H22.25C23.4926 9.75 24.5 10.7574 24.5 12C24.5 13.2426 23.4926 14.25 22.25 14.25H16.25V20.25C16.25 21.4926 15.2426 22.5 14 22.5C12.7574 22.5 11.75 21.4926 11.75 20.25V14.25H5.75C4.50736 14.25 3.5 13.2426 3.5 12C3.5 10.7574 4.50736 9.75 5.75 9.75H11.75V3.75Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_26_46405",
    x: 0.5,
    y: 0,
    width: 27,
    height: 27,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.0745098 0 0 0 0 0.101961 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_26_46405"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_26_46405",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursorCrosshair);
export default __webpack_public_path__ + "static/media/cursorCrosshair.b71db5edf696abb84241535a882d6098.svg";
export { ForwardRef as ReactComponent };